<template>
  <div class="overflow-auto max-h-full">
    <div class="flex justify-between p-4 items-center modal-custom_header">
      <div>
        <h4 class="m-0 text-center">
          {{ lesson.lessonName }}
        </h4>
      </div>

      <div>
        <button @click="$emit('close')">
          <i class="fal fa-times fa-lg" />
        </button>
      </div>
    </div>

    <div class="modal-custom_body">
      <div
        v-for="(score, index) in reversedArray"
        :key="score.answerId"
      >
        <div v-if="index == lesson.score.totalQuestions" class="text-center my-6">
          <span>Previous Attempts</span>
          <hr/>
        </div>

        <div class="modal-custom_item p-4">
          <b class="mb-2 block">
            {{ score.description }}
          </b>

          <div v-show="isCorrect(score)">
            <div class="flex">
              <div class="mr-3">
                <Icon :type="isCorrect(score) ? 'completed' : 'expired'" />
              </div>
              <p class="text-xl">
                {{ score.learnerResponse }}
              </p>
            </div>
          </div>

          <div v-show="!isCorrect(score)">
            <div class="flex">
              <div class="mr-3">
                <Icon :type="'completed'" />
              </div>
              <p class="text-xl">
                {{ score.correctResponses }}
              </p>
            </div>
            <div class="flex">
              <div class="mr-3">
                <Icon :type="'expired'" />
              </div>
              <p class="text-xl">
                {{ score.learnerResponse }}
              </p>
            </div>
          </div>
        </div>

        <hr
          v-if="index != lesson.score.questions.length - 1"
          class="mt-3 mb-0"
        >
      </div>
    </div>
  </div>
</template>

<script>
import Icon from "@components/UIComponents/TopicIcon/Icon";
export default {
  components: {
    Icon
  },
  props: {
    lesson: {
      type: Object,
      default: () => {}
    }
  },
  emits: ["close"],
  data() {
    return {
      reversedArray:[]
    };
  },
  created () {
    this.reversedArray = this.lesson.score.questions.slice().reverse();
  },
  methods: {
    isCorrect(score) {
      return score.result === 'correct';
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/sass/paper/variables";
@media (max-width: 768px) {
  .btn-custom {
    padding: 5px 10px !important;
  }
}
.modal-custom {
  &_header {
    background-color: $light-gray;
  }
  &_body {
    overflow-y: scroll;
    max-height: 600px;
  }
  &_item {
    margin: auto 10px;
  }
}
</style>
